import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from "../../core/menu/menu.component";
import { CoreModule } from "../../core/core.module";
import {MatTooltipModule} from "@angular/material/tooltip";


@NgModule({
  declarations: [
    MainLayoutComponent,
    HeaderComponent,
    MenuComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        CoreModule,
        MatTooltipModule,
    ]
})
export class LayoutModule { }
